import { useState, useEffect } from "react";
import { ChevronDown, Menu, X } from "lucide-react";
import { Link, useLocation, useNavigate } from "react-router-dom";

export default function NewNavbar() {
  const [open, setOpen] = useState(false);
  const [servicesOpen, setServicesOpen] = useState(false);
  const [loginOpen, setLoginOpen] = useState(false);
  const [orgOpen, setOrgOpen] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  return (
    <header className="w-full relative z-50">
      <div className="w-full flex items-center justify-between px-10 py-3">
        {/* Logo Section */}
        <div className="flex items-center space-x-2">
          <Link to="/">
            <img
              src="http://res.cloudinary.com/dt8emxboh/image/upload/v1773043155/s9nuu1pftexlayt6tuif.png"
              alt="KuppiSmart Logo"
              className="h-8 w-auto"
            />
          </Link>
        </div>

        {/* Desktop Menu */}
        <nav className="hidden md:flex items-center space-x-8  px-6 py-2 rounded">
          <Link to="/" className="hover:text-green-600 font-bold transition">
            Home
          </Link>

          <div className="relative">
            <div
              onClick={() => setServicesOpen((prev) => !prev)}
              className="flex items-center gap-1 cursor-pointer font-bold hover:text-green-600 transition"
            >
              Services <ChevronDown size={16} />
            </div>

            {servicesOpen && (
              <div className="absolute top-10 left-0 bg-white shadow-lg rounded-md w-56 text-black py-2 z-50">
                <div
                  onClick={() => {
                    if (location.pathname === "/aqua-monitoring") {
                      setServicesOpen(false);
                    } else {
                      navigate("/aqua-monitoring");
                      setServicesOpen(false);
                    }
                  }}
                  className="flex justify-between items-center px-4 py-2 hover:bg-gray-100 cursor-pointer"
                >
                  <span>Aqua Monitoring</span>
                  <span>➜</span>
                </div>

                <div
                  onClick={() => {
                    if (location.pathname === "/stp-monitoring") {
                      setServicesOpen(false);
                    } else {
                      navigate("/stp-monitoring");
                      setServicesOpen(false);
                    }
                  }}
                  className="flex justify-between items-center px-4 py-2 hover:bg-gray-100 cursor-pointer"
                >
                  <span>STP Monitoring</span>
                  <span>➜</span>
                </div>

                <div
                  onClick={() => {
                    if (location.pathname === "/gas-monitoring") {
                      setServicesOpen(false);
                    } else {
                      navigate("/gas-monitoring");
                      setServicesOpen(false);
                    }
                  }}
                  className="flex justify-between items-center px-4 py-2 hover:bg-gray-100 cursor-pointer"
                >
                  <span>Gas Monitoring</span>
                  <span>➜</span>
                </div>

                <div
                  onClick={() => {
                    if (location.pathname === "/poultry") {
                      setServicesOpen(false);
                    } else {
                      window.open("https://livestockify.com", "_blank");
                      setServicesOpen(false);
                    }
                  }}
                  className="flex justify-between items-center px-4 py-2 hover:bg-gray-100 cursor-pointer"
                >
                  <span>Poultry</span>
                  <span>➜</span>
                </div>
              </div>
            )}
          </div>

          <Link
            to="/about"
            className="hover:text-green-600 font-bold transition"
          >
            About Us
          </Link>

          <Link
            to="/new-blog"
            className="hover:text-green-600 font-bold transition"
          >
            Blog
          </Link>
        </nav>

        {/* Login Button */}

        <div className="hidden md:block relative">
          <button
            onClick={() => setLoginOpen(!loginOpen)}
            className="flex items-center gap-1 bg-[#6FAF1E] text-white px-5 font-bold py-2 rounded-lg hover:bg-green-700 transition"
          >
            Login <ChevronDown size={20} />
          </button>

          {loginOpen && (
            <div className="absolute right-0 mt-2 w-56 bg-white text-black text-left shadow-lg rounded-md py-2 z-50">
           

              <div>
                {/* Organisation Toggle */}
                <div
                  onClick={() => setOrgOpen(!orgOpen)}
                  className="flex justify-between items-center px-4 py-2 hover:bg-gray-100 font-medium cursor-pointer"
                >
                  <span>Organisation Login</span>
                  <ChevronDown
                    size={16}
                    className={`transition-transform ${
                      orgOpen ? "rotate-180" : ""
                    }`}
                  />
                </div>

                {/* Company List (EXPAND) */}
                {orgOpen && (
                  <div className="border-t mt-1">
                    <div
                      onClick={() =>
                        window.open(
                          "https://www.kuppismart.com/chennai-login",
                          "_blank",
                        )
                      }
                      className="flex items-center gap-3 px-4 py-2 hover:bg-gray-100 cursor-pointer"
                    >
                      <img
                        src="http://res.cloudinary.com/dt8emxboh/image/upload/v1774943827/yklwimxoozpbbrgyjlrh.jpg"
                        className="w-6 h-6 rounded-full object-cover"
                        alt="Avris"
                      />
                      <span>Avris</span>
                    </div>
                    <div
                      onClick={() => {
                        navigate("/urjabio-login");
                        setLoginOpen(false);
                      }}
                      className="flex items-center gap-3 px-4 py-2 hover:bg-gray-100 cursor-pointer"
                    >
                      <img
                        src="https://res.cloudinary.com/dt8emxboh/image/upload/v1784871291/mxqft9vrst6ung9efsgo.png"
                        className="w-6 h-6 rounded-full object-cover"
                        alt="Urja Bio"
                      />
                      <span>Urja Bio</span>
                    </div>
                  </div>
                )}
              </div>

              <Link
                to="/admin-login"
                className="block px-4 py-2 hover:bg-gray-100 font-medium"
              >
                Admin Login
              </Link>
            </div>
          )}
        </div>

        {/* Mobile Menu Icon */}
        <div className="md:hidden">
          {open ? (
            <X size={28} onClick={() => setOpen(false)} />
          ) : (
            <Menu size={28} onClick={() => setOpen(true)} />
          )}
        </div>
      </div>

      {/* Mobile Menu */}
      {open && (
        <div className="md:hidden text-1xl font-semibold text-left px-6 pb-4 space-y-3">
          <Link to="/" className="block">
            Home
          </Link>

          <div
            onClick={() => setServicesOpen(!servicesOpen)}
            className="block cursor-pointer"
          >
            Services
          </div>
          {servicesOpen && (
            <div className="pl-4 space-y-2">
              <Link to="/aqua-monitoring" className="block">
                Aqua Monitoring
              </Link>
              <Link to="/stp-monitoring" className="block">
                STP Monitoring
              </Link>
              <Link to="/gas-monitoring" className="block">
                Gas Monitoring
              </Link>
              <Link to="/poultry" className="block">
                Poultry Monitoring
              </Link>
            </div>
          )}

          <Link to="/about" className="block">
            About Us
          </Link>
          <Link to="/new-blog" className="block">
            Blog
          </Link>
          {/* <button className="w-full bg-green-600 text-white py-2 rounded">
            Login
          </button> */}

<div>
  <button
    onClick={() => setLoginOpen(!loginOpen)}
    className="w-full bg-green-600 text-white py-2 rounded flex justify-center items-center gap-2"
  >
    Login <ChevronDown size={16} />
  </button>

  {loginOpen && (
    <div className="mt-2 bg-white text-black rounded-md shadow-md py-2">

     

      {/* Organisation Toggle */}
      <div>
        <div
          onClick={() => setOrgOpen(!orgOpen)}
          className="flex justify-between items-center px-4 py-2 hover:bg-gray-100 font-medium cursor-pointer"
        >
          <span>Organisation Login</span>
          <ChevronDown
            size={16}
            className={`transition-transform ${orgOpen ? "rotate-180" : ""}`}
          />
        </div>

        {orgOpen && (
          <div className="border-t">
            <div
              onClick={() => {
                window.open("https://www.kuppismart.com/chennai-login", "_blank");
                setOpen(false);
              }}
              className="flex items-center gap-3 px-4 py-2 hover:bg-gray-100 cursor-pointer"
            >
              <img
                src="http://res.cloudinary.com/dt8emxboh/image/upload/v1774943827/yklwimxoozpbbrgyjlrh.jpg"
                className="w-6 h-6 rounded-full object-cover"
                alt="Avris"
              />
              <span>Avris</span>
            </div>

            <div
              onClick={() => {
                navigate("/urjabio-login");
                setOpen(false);
                setLoginOpen(false);
              }}
              className="flex items-center gap-3 px-4 py-2 hover:bg-gray-100 cursor-pointer"
            >
              <img
                src="https://res.cloudinary.com/dt8emxboh/image/upload/v1784871291/mxqft9vrst6ung9efsgo.png"
                className="w-6 h-6 rounded-full object-cover"
                alt="Urja Bio"
              />
              <span>Urja Bio</span>
            </div>

            <div>
              <Link
                to="/farmer-login"
                className="block px-4 py-2 hover:bg-gray-100 font-medium"
                onClick={() => setOpen(false)}
              >
                Farmer Login
              </Link>
            </div>
          </div>
        )}
      </div>


      <Link
        to="/admin-login"
        className="block px-4 py-2 hover:bg-gray-100 font-medium"
        onClick={() => setOpen(false)}
      >
        Admin Login
      </Link>
    </div>
  )}
</div>

        </div>
      )}
    </header>
  );
}
